import React, { Component } from 'react'
import TweetLayout from '../components/TweetLayout'
import portfolio from '../portfolio.json'

export default class skills extends Component {
  render() {
    return (
      <TweetLayout portfolio={portfolio}/>
    )
  }
}

